export const convertToUserTime = (utcTime: string, omitTime: boolean = false): string => {
  // Ensure the UTC time string is properly formatted
  let dateString = utcTime.trim();
  
  // If the string doesn't explicitly indicate UTC (no 'Z' or timezone offset), treat it as UTC
  if (dateString && !dateString.endsWith('Z') && !/[+-]\d{2}:\d{2}$/.test(dateString)) {
    // Add 'Z' to indicate UTC if not present
    dateString = dateString + 'Z';
  }
  
  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return '-';
  }

  if (omitTime) {
    return date.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  }

  return date.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};



